import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcLogoGray = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 81,
	height: 81,
	viewBox: "0 0 81 81",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M46.2998 67.6079C46.2998 68.3767 45.6766 68.9999 44.9079 68.9999H36.0919C35.3231 68.9999 34.6999 68.3767 34.6999 67.6079L34.6999 53.9405L20.812 68.0554C20.2728 68.6034 19.3915 68.6105 18.8435 68.0713L12.5593 61.8883C12.0113 61.3491 12.0042 60.4678 12.5433 59.9198L26.436 45.8001H12.892C12.1232 45.8001 11.5 45.1769 11.5 44.4081V35.5922C11.5 34.8234 12.1232 34.2002 12.892 34.2002H34.6999L34.6999 45.8001H34.7006V34.2004H46.3005V45.8003H46.2998V67.6079Z",
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.7007 44.4077C34.7007 45.1765 35.3239 45.7997 36.0927 45.7997H68.1085C68.8773 45.7997 69.5005 45.1765 69.5005 44.4077V35.5918C69.5005 34.823 68.8773 34.1998 68.1085 34.1998L46.3006 34.1998L46.3006 12.392C46.3006 11.6232 45.6774 11 44.9086 11L36.0927 11C35.3239 11 34.7007 11.6232 34.7007 12.392L34.7007 44.4077Z",
			fill: "#CED2DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.7012 34.2002H46.3011V45.8001H35.7909C35.1891 45.8001 34.7012 45.3122 34.7012 44.7104V34.2002Z",
			fill: "#EDF0F4"
		})
	]
});
export default SvgIcLogoGray;
